import * as Yup from 'yup';

// Supplier fields
export const supplierFields = [
  { key: "name", label: "Name", type: "text", required: true },
  { key: "supplierStatus", label: "Status", type: "select", required: true },
  { key: "currency", label: "Currency", type: "select", required: true },
  { key: "payment_terms", label: "Payment Term", type: "select", required: true },
  { key: "attribute_set", label: "Attribute Set", type: "select", required: false },
  { key: "taxRule", label: "Tax Rule", type: "select", required: true },
  { key: "defaultCarrier", label: "Default Carrier", type: "select", required: false },
  { key: "discount", label: "number", type: "number", required: false },
  { key: "taxNumber", label: "Tax Number", type: "number", required: false },
  { key: "comments", label: "Comments", type: "textField", required: false },
];

// Initial Values
export const supplierInitialValues = {
  name: '',
  type: '',
  comments: '',
  discount: '',
  tax_rule: '',
  payment_terms: '',
  currency: '',
  status: '',
  tax_number: '',
  default_carrier: '',
  fax: '',
  website: '',
  contacts: [],
  addresses: [],
}

// Validation Schema
export const supplierValidationSchema = Yup.object().shape(
  supplierFields.reduce((schema, item) => {
    let validator = Yup.string(); // default

    if (item.key === 'email') {
      validator = Yup.string().email(`Enter a valid ${item.label}`);
    } else if (item.key === 'phone' || item.label.toLowerCase().includes('phone')) {
      validator = Yup.string().matches(/^\d+$/, `Enter a valid ${item.label}`);
    } else if (item.type === 'toggle') {
      validator = Yup.boolean();
    }

    if (item.minLength) {
      validator = validator.min(item.minLength, `${item.label} must be at least ${item.minLength} characters`);
    }
    if (item.maxLength) {
      validator = validator.max(item.maxLength, `${item.label} must be at most ${item.maxLength} characters`);
    }

    if (item.required) {
      validator = validator.required(`${item.label} is required`);
    }

    schema[item.key] = validator;
    return schema;
  }, {})
);
